import script from "./ProductCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCard.vue?vue&type=script&lang=ts&setup=true"

import "./ProductCard.vue?vue&type=style&index=0&id=1ea9c49c&lang=scss"

const __exports__ = script;

export default __exports__